module.exports = {
  user_default_email: '',
  user_dafault_pw: '',

  stripe_pk: process.env.REACT_APP_STRIPE_PK,
  stripe_beta: process.env.REACT_APP_STRIPE_BETA,

  // keys below here need to be set on heroku:
};
